function testimonialsSlider() {
  $(document).ready(function() {
    if ($('.testimonials-container').length) {
      var testimonialsSlider = new Splide('#testimonials-container', {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        focus: 'center',
        autoplay: true,
        arrows: true,
        pagination: false,
      });

      testimonialsSlider.mount();
    }
  });
}
